/* Comformidable â€” scroll-reveal micro-interactie (homepage).
   Content is standaard zichtbaar; .cf-reveal wordt pas via JS gezet,
   dus zonder JS of bij reduced-motion verandert er niets. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (!document.body.classList.contains('template-index')) return;

  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) sections = document.querySelectorAll('main .shopify-section');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('cf-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  sections.forEach(function (s, i) {
    if (i === 0) return; // hero nooit verbergen (LCP)
    var r = s.getBoundingClientRect();
    if (r.top < window.innerHeight) return; // al in beeld bij load: niet animeren
    s.classList.add('cf-reveal');
    io.observe(s);
  });
})();
